import React from "react";
import EditEmployeeForm from "../../../forms/editemployeeform";

const EditEmployeeMidComp=()=>{
    return(
        <EditEmployeeForm></EditEmployeeForm>
    )
}

export default EditEmployeeMidComp;